function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSunny = function SvgSunny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    width: "36px",
    height: "36px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "scale(0.8)"
    }
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.833333s infinite normal forwards running breath"
    }
  }, React.createElement("circle", {
    fill: "#ffdc6c",
    clipRule: "evenodd",
    fillRule: "evenodd",
    r: 23.3,
    cy: 37.7,
    cx: 33.3,
    style: {
      fill: "rgb(255, 220, 108)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.11111s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#b5b5b5",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M78.5 58.1c.6-1.9.9-3.9.9-5.9 0-10.8-8.8-19.6-19.6-19.6-7.5 0-14 4.2-17.3 10.4-1.2-.4-2.6-.6-3.9-.6-7.2 0-13 5.8-13 13 0 .9.1 1.8.3 2.6-6.6 1-11.7 6.8-11.7 13.7 0 7.7 6.2 13.9 13.9 13.9h48.1c7.7 0 13.9-6.2 13.9-13.9-.1-6.8-5.1-12.5-11.6-13.6z",
    style: {
      fill: "rgb(181, 181, 181)"
    }
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSunny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sunny.dafd3ab1.svg";
export { ForwardRef as ReactComponent };